import * as THREE from 'three';

export class GridMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        time: { value: 0 },
        gridColor: { value: new THREE.Color(0xff00ff) },
        gridColor2: { value: new THREE.Color(0x00ffff) },
        baseColor: { value: new THREE.Color(0x0a0a0f) },
        gridSpacing: { value: 5.0 },
        lineWidth: { value: 0.03 },
        fadeStart: { value: 50.0 },
        fadeEnd: { value: 200.0 },
        scrollSpeed: { value: 2.0 },
      },
      vertexShader: `
        varying vec2 vUv;
        varying vec3 vWorldPosition;

        void main() {
          vUv = uv;
          vec4 worldPos = modelMatrix * vec4(position, 1.0);
          vWorldPosition = worldPos.xyz;
          gl_Position = projectionMatrix * viewMatrix * worldPos;
        }
      `,
      fragmentShader: `
        uniform float time;
        uniform vec3 gridColor;
        uniform vec3 gridColor2;
        uniform vec3 baseColor;
        uniform float gridSpacing;
        uniform float lineWidth;
        uniform float fadeStart;
        uniform float fadeEnd;
        uniform float scrollSpeed;

        varying vec2 vUv;
        varying vec3 vWorldPosition;

        void main() {
          // World-space coordinates for grid (static, no scrolling)
          vec2 worldUv = vWorldPosition.xz;

          // Grid pattern
          vec2 grid = abs(fract(worldUv / gridSpacing - 0.5) - 0.5);
          vec2 gridWidth = fwidth(worldUv / gridSpacing);

          vec2 lines = smoothstep(gridWidth * 0.5, gridWidth * 1.5, grid);
          float gridMask = 1.0 - min(lines.x, lines.y);

          // Add thicker lines every N units
          vec2 majorGrid = abs(fract(worldUv / (gridSpacing * 5.0) - 0.5) - 0.5);
          vec2 majorGridWidth = fwidth(worldUv / (gridSpacing * 5.0));
          vec2 majorLines = smoothstep(majorGridWidth * 0.3, majorGridWidth * 1.0, majorGrid);
          float majorGridMask = 1.0 - min(majorLines.x, majorLines.y);

          // Distance fade
          float dist = length(vWorldPosition.xz);
          float fade = 1.0 - smoothstep(fadeStart, fadeEnd, dist);

          // Combine colors
          vec3 minorColor = gridColor * gridMask * fade * 0.6;
          vec3 majorColor = gridColor2 * majorGridMask * fade;

          // Glow effect based on distance from origin
          float centerGlow = exp(-dist * 0.02) * 0.3;
          vec3 glowColor = mix(gridColor, gridColor2, sin(time) * 0.5 + 0.5) * centerGlow;

          vec3 finalColor = baseColor + minorColor + majorColor + glowColor;

          // Add subtle pulsing
          float pulse = sin(time * 2.0) * 0.05 + 0.95;
          finalColor *= pulse;

          gl_FragColor = vec4(finalColor, 1.0);
        }
      `,
      side: THREE.DoubleSide,
    });
  }

  public update(time: number): void {
    this.uniforms.time.value = time;
  }
}
